import SearchLayout from './container/index';

export default SearchLayout;



// WEBPACK FOOTER //
// ./src/views/Setup/SearchLayout/index.js